import { useCallback, useEffect, useState } from 'react'
import { getApi } from '@BUP/services/Axios'

export const useGetUsersByCourseIds = (coursesId = [], roleType) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const getUsersByCourse = useCallback(async () => {
    if (coursesId.length === 0) return

    setLoading(true)
    setError(null)

    try {
      const requests = coursesId.map(async courseId => {
        const api = await getApi('schools', { version: 4 })
        const response = await api.get(
          `/courses/${courseId}/enrollments?limit=1000&filter[role][type]=${roleType}&include=user`
        )

        return {
          courseId,
          count:
            parseInt(response.headers['x-total-count'], 10) ||
            (Array.isArray(response.data) ? response.data.length : 0),
          data: response.data
        }
      })

      const results = await Promise.all(requests)
      setData(results)
    } catch (err) {
      if (err.response) {
        console.error('Server responded with error:', err.response.status, err.response.data)
      } else if (err.request) {
        console.error('No response received. Request details:', err.request)
      } else {
        console.error('Error setting up request:', err.message)
      }
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [coursesId, roleType])

  useEffect(() => {
    getUsersByCourse()
  }, [getUsersByCourse])

  return { data, loading, error, refetch: getUsersByCourse }
}
